module.exports = __webpack_public_path__ + "static/media/gallery_08_thumb.13ab4ccc.jpg";